import {
  EnableDisablePersonMutation,
  UpdateAccountStatus_Input,
  useEnableDisablePersonMutation,
  UserTableDocument,
  UserTableQuery
} from 'generated/graphql';
import _ from 'lodash';
import { gqlCacheUtil } from 'modules/common';
import React from 'react';

export function useEnableDisableAccount() {
  const [
    fnMutate,
    tuple
  ] = useEnableDisablePersonMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (input: UpdateAccountStatus_Input) => {
      await fnMutate({
        variables: {
          input
        },
        updateQueries: {
          ...gqlCacheUtil.genUpdateQueryMap<UserTableQuery, EnableDisablePersonMutation>(
            UserTableDocument,
            (prevState, { mutationResult }) => ({
              ...prevState,
              persons: {
                ...prevState.persons,
                nodes: _.compact(prevState.persons.map((node) => {
                  if (node.id === mutationResult.data?.updateAccountStatus?.id) {
                    return {
                      ...node,
                      isActive: !node.isActive
                    };
                  } else {
                    return node;
                  }
                }))
              }
            })
          )
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
